import { ValidatorFn, Validators } from '@angular/forms';

export function emailValidator(): ValidatorFn
{
  return Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$');
}
